// extracted by mini-css-extract-plugin
export default {"modal-window":"Modal_modal-window__Xmlf4","modal-container":"Modal_modal-container__h3mey"};